export async function lightbox() {
    const lightboxTrigger = document.querySelectorAll('[data-lightbox]');

    if (lightboxTrigger) {
        const { initLighboxes } = await import(/* webpackMode: "lazy" */ './lightbox.async');

        initLighboxes();
    }
}
